(function () {
    'use strict';

    angular
        .module('travelExpenses')
        .controller('TravelExpensesReportController', TravelExpensesReportController);

    TravelExpensesReportController.$inject = ['$state', '$uibModal','toastr', 'CitiesByExpoService', 'TravelExpenseService', 'ExpoService', 'SellerService', 'expenseTypeList', 'paymentTypeList', 'CurrentUser'];
    function TravelExpensesReportController($state, $uibModal, toastr, CitiesByExpoService, TravelExpenseService, ExpoService, SellerService, expenseTypeList, paymentTypeList, CurrentUser) {

        var vm = this;
        vm.datePicker             = {"autoApply": true};
        vm.expenseTypeSelected    = {};
        vm.expenseTypeList        = expenseTypeList;
        vm.paymentTypeSelected    = {};
        vm.paymentTypeList        = paymentTypeList;
        vm.dateOptions            = {
            locale: {
                format: 'MM/DD/YYYY',
                cancelLabel: 'Close'
            }
        };
        vm.selectOptionAll = [{
            name: '--- All ---',
            id: -1
        }];
        vm.description            = '';
        vm.expenseDate            = {};
        vm.expoSelected           = {};
        vm.citySelected           = {};
        vm.cities                 = [];
        vm.expos                  = [];
        vm.query                  = [];
        vm.expenses               = [];
        vm.sellers                = [];
        vm.sellerSelected         = '';
        vm.othersEventsSelected   = {};
        vm.othersEventsList       = [];
        vm.validadeApproveList    = [];
        vm.convertToUTC           = convertToUTC;
        vm.selectExpo             = selectExpo;
        vm.loadSellers            = loadSellers;
        vm.getOthersEvents        = getOthersEvents;
        vm.selectCitiesByExpo     = selectCitiesByExpo;
        vm.getByFilter            = getByFilter;
        vm.deleteTravelExpense    = deleteTravelExpense;
        vm.amouts                 = [];
        vm.changeAmount           = changeAmount;
        vm.approveList            = [];
        vm.approveExpenses        = approveExpenses;
        vm.viewTravelExpense      = viewTravelExpense;
        vm.checkAll               = checkAll;
        vm.checkedAll             = false;
        vm.addItemValidateList    = addItemValidateList  
        vm.removeItemValidateList = removeItemValidateList;
        vm.toggleValidate         = toggleValidate; 
        vm.clearFilter            = clearFilter; 
        vm.isApprovedSelected     = -1;
        vm.isApproved             = [
            {id : -1, name : '-- All --'},
            {id : 1, name : 'Yes'},
            {id : 0, name : 'No'}
        ];

        vm.copiedToClipboard      = copiedToClipboard;
        vm.goToEdit               = goToEdit;
        vm.revertApprovedExpense  = revertApprovedExpense;

        /*PAGINATION*/
        vm.pageChanged            = pageChanged;
        vm.setPage                = setPage;
        vm.totalItems             = [];
        vm.to                     = [];
        vm.currentPage            = null;
        vm.itemsPerPage           = [];
        vm.page                   = 1;

        function activate() {
            vm.loadSellers();
            vm.getByFilter();
            vm.selectExpo();
        }

        function convertToUTC(date)
        {
            return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()));
        }

        function loadSellers() {
            SellerService.getStaff().then(function(response) {
                vm.sellers = vm.selectOptionAll.concat(response.data);
            }).catch(function(err) {
            });
        }

        function getOthersEvents() {
            EventsService.getOthersEvents().then(function(response){
                vm.othersEventsList = response.data;
            });
        }

        function selectExpo () {
            ExpoService.getExpos().then(function(response){
                vm.expos = response.data;
            }).catch(function(err) {
            });
        }

        function selectCitiesByExpo () {
            vm.citySelected = {};
            CitiesByExpoService.getCities(vm.expoSelected.id).then(function(response){
                vm.cities = response.data;
                vm.cities.unshift({location_id : -1, city_name: '-- All --'});
                vm.citySelected = {location_id : -1, city_name: '-- All --'};
                if (vm.expense) {
                    vm.citySelected = $filter('filter')(vm.cities, {expos_locations_id: vm.expense.expo_location_id})[0];
                }
            }).catch(function(err) {
            });
        }

        function getByFilter() {
            var query = {};

            if (TravelExpenseService.filters) {
                vm.expenseDate  = TravelExpenseService.filters.expenseDate; 
                vm.expoSelected = TravelExpenseService.filters.expoSelected; 
                vm.citySelected = TravelExpenseService.filters.citySelected; 
                vm.othersEventsSelected = TravelExpenseService.filters.othersEventsSelected; 
                vm.filePath = TravelExpenseService.filters.filePath; 
                vm.picture = TravelExpenseService.filters.picture; 
                vm.selectedCurrency = TravelExpenseService.filters.selectedCurrency; 
                vm.value = TravelExpenseService.filters.value; 
                vm.description = TravelExpenseService.filters.description; 
                vm.expenseTypeSelected = TravelExpenseService.filters.expenseTypeSelected; 
                vm.paymentTypeSelected = TravelExpenseService.filters.paymentTypeSelected; 
                vm.sellerSelected = TravelExpenseService.filters.sellerSelected; 
                vm.isApprovedSelected = TravelExpenseService.filters.isApprovedSelected; 
                vm.page = TravelExpenseService.filters.page; 
            }

            TravelExpenseService.filters = null;
            
            if (typeof vm.expenseDate.startDate !== 'undefined' && typeof vm.expenseDate.endDate !== 'undefined') {
                query['start_date'] = vm.convertToUTC(new Date(vm.expenseDate.startDate));
                query['end_date'] = vm.convertToUTC(new Date(vm.expenseDate.endDate));
            }
            if (typeof vm.expoSelected !== 'undefined' && vm.expenseTypeSelected.id == 'physical_event') {
                query['expo_id'] = vm.expoSelected.id;
            }
            if (typeof vm.citySelected !== 'undefined' && vm.expenseTypeSelected.id == 'physical_event' && vm.citySelected.location_id > -1) {
                query['location_id'] = vm.citySelected.location_id;
            }
            if (typeof vm.othersEventsSelected !== 'undefined' && vm.othersEventsSelected.id !== 'other_event') {
                query['other_event_id'] = vm.othersEventsSelected.id;
            }
            if (typeof vm.filePath !== 'undefined' && vm.filePath !== '') {
                query['file_path'] = vm.filePath;
            }
            if (typeof vm.picture !== 'undefined' && vm.picture !== '') {
                query['file_path'] = vm.picture;
            }
            if (typeof vm.selectedCurrency !== 'undefined' && vm.selectedCurrency !== '') {
                query['currency'] = vm.selectedCurrency.code;
            }
            if (typeof vm.value !== 'undefined' && vm.value !== '') {
                query['value'] = vm.value;
            }
            if (typeof vm.description !== 'undefined') {
                query['description'] = vm.description;
            }
            if (typeof vm.expenseTypeSelected !== 'undefined' && vm.expenseTypeSelected.id !== 'all') {
                query['type'] = vm.expenseTypeSelected.id;
            }
            if (typeof vm.paymentTypeSelected !== 'undefined' && vm.paymentTypeSelected.id !== 'all') {
                query['payment_type'] = vm.paymentTypeSelected.id;
            }
            if (typeof vm.sellerSelected !== 'undefined') {
                query['seller_id'] = vm.sellerSelected.id;
            }
            query['is_approved'] = vm.isApprovedSelected;
            query['page'] = vm.page;
            
            TravelExpenseService.getExpense(query).then(function(response){
                vm.expenses = response.data.data.map(function (value) {
                    value.expand = false;
                    return value;
                });
                vm.totalItems = response.data.total;
                vm.to = response.data.to;
                vm.setPage(response.data.current_page);
                vm.itemsPerPage = response.data.per_page;
            }).catch(function(err) {
            });
        }

        function deleteTravelExpense(expense) {
            $uibModal.open({
                templateUrl: 'templates/travelexpenses/deleteExpense/template.modal.html',
                controller: 'DeleteTravelExpensesController',
                controllerAs:'DeleteExpense',
                resolve:
                    {
                        expense : function () {
                            return expense;
                        },
                        expensesList  : function () {
                            return vm.expenses;
                        }
                    }
            });
        }

        function setPage (pageNo) {
            vm.currentPage = pageNo;
        }

        function pageChanged (pageNo) {
            vm.page = vm.currentPage;
            vm.getByFilter();
        }

        function changeAmount(expense) {

            vm.query = {};
            vm.query['id'] = expense.id;
            vm.query['new_amount'] = expense.amount_usd;
            TravelExpenseService.changeAmount(vm.query).then(function(response){
                expense.amount = response.data.amount;
                expense.amount_usd = response.data.amount_usd;
                expense.exchange_rate_usd = response.data.exchange_rate_usd;
                angular.forEach(expense.children, function(value, key) {
                    value.amount_usd = value.amount * expense.exchange_rate_usd;
                    value.exchange_rate_usd = expense.exchange_rate_usd;
                });
                toastr.success('Successfully saved!');
            }).catch(function(err) {
            });
        }
        function approveExpenses() {
            vm.query = {};
            vm.query['expenses'] = vm.expenses;
            
            TravelExpenseService.approveExpenses(vm.query).then(function(response){
                //expense.amount = response.data.amount;
                vm.getByFilter();
            }).catch(function(err) {
            });
        }

        function viewTravelExpense(expense) {
            $uibModal.open({
                templateUrl: 'templates/travelexpenses/viewTravelExpenseModal/viewTravelExpenseModal.html',
                controller: 'ViewTravelExpenseModalController',
                controllerAs:'ViewTravelExpenseModal',
                resolve: {
                    expense : function () {
                        return expense;
                    },
                    mode: function(){
                        return 'edit';
                    },
                    expenseTypeList: function(){
                        return vm.expenseTypeList;
                    },
                    paymentTypeList: function(){
                        return vm.paymentTypeList;
                    },
                    expenseTypeList: function() {
                        return vm.expenseTypeList
                    },
                    paymentTypeList: function() {
                        return vm.paymentTypeList;
                    },
                    user: function() {
                        return CurrentUser;
                    }
                }
            });
        }

        function checkAll()
        {
            if(vm.checkedAll === true){
                angular.forEach(vm.expenses, function(value, key) {
                    value.expanded = true;
                    value.checked = true;
                    vm.addItemValidateList(value);
                    angular.forEach(value.children, function(value_children, key) {
                        value_children.expanded = true;
                        value_children.checked = true;
                        vm.addItemValidateList(value_children);
                    });
                });
                
            } else {
                angular.forEach(vm.expenses, function(value, key) {
                    value.expanded = false;
                    value.checked = false;
                    vm.removeItemValidateList(value);
                    angular.forEach(value.children, function(value_children, key) {
                        value_children.expanded = false;
                        value_children.checked = false;
                        vm.removeItemValidateList(value_children);
                    });
                });
                
            }
        }

        function toggleValidate(expense) {
            if (vm.validadeApproveList.indexOf(expense) > -1) {
                vm.removeItemValidateList (expense);
            } else {
                vm.addItemValidateList(expense);
            }
        }

        function addItemValidateList (expense) {
            vm.validadeApproveList.push(expense); 
        }

        function removeItemValidateList (expense) {
            vm.validadeApproveList.splice(vm.validadeApproveList.indexOf(expense), 1); 
        }

        function goToEdit(expense) {
            let params = {expenseId:expense.id, origin:'approval'};

            TravelExpenseService.setFilters(vm);
            $state.go("root.travel_expenses.edit", params);
        }

        function clearFilter() {
            vm.expenseDate = {};
            vm.expenseTypeSelected = {};
            vm.description = '';
            vm.paymentTypeSelected = {};
            vm.sellerSelected = '';
            vm.expoSelected = '';
            vm.citySelected = '';
            vm.isApprovedSelected = -1;
        }

        function copiedToClipboard () {
            toastr.success('Copied to clipboard!');
        }

        function revertApprovedExpense(expense) {

        }

        function revertApprovedExpense(expense) {
            $uibModal.open({
                templateUrl: 'templates/travelexpenses/revertExpense/template.modal.html',
                controller: 'RevertTravelExpensesController',
                controllerAs:'RevertExpense',
                resolve:
                    {
                        expense : function () {
                            return expense;
                        },
                        expensesList  : function () {
                            return vm.expenses;
                        },
                        travelExpenseController : function () {
                            return vm;
                        }
                    }
            });
        }
        
        activate();
    }

    

})();